import {
    TasksFilterData, Task, LeaveType
} from '../types/TasksFilterData';
import { fetchFromApi, fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { getUsers } from '../services/dependencies';
import { useCurrentUser } from './useCurrentUser';

type LeaveTypeApi = {
    id?: number;
    taskId?: number;
    name: string;
    userId: number;
};

export async function getAllTasks(): Promise<TasksFilterData> {
    const { getCurrentUser } = useCurrentUser();
    const currentUser = getCurrentUser();

    const allTasks: Task[] = await fetchFromApi('/api/schedule/tasks/definitions');
    let leaveTasks: LeaveType[] = [];

    const tasks = allTasks.filter((task) => task.isLeave !== true);

    if (currentUser?.permissions?.includes('can_view_all_teams') && currentUser?.permissions?.includes('can_view_leave_type')) {
        
        leaveTasks = allTasks
            .filter((task) => task.isLeave === true)
            .map((task) => ({
                id: task.id,
                name: task.name,
                userId: 0
            }))
            .sort((a, b) => a.name.localeCompare(b.name));
    } else if (!currentUser?.permissions?.includes('can_view_all_teams') && currentUser?.permissions?.includes('can_view_leave_type')) {

        // get userIds:
        const users = await getUsers();
        const userIds = users.map((user) => user.id).join(',');
        const apiLeaveTypes = await fetchFromLambda<LeaveTypeApi[]>('/schedule/v3/shifts/published/leaves', {
            method: 'POST',
            body: JSON.stringify({ userIds })
        }
        );

        // Get leave task IDs from allTasks for filtering
        const leaveTaskIds = new Set(allTasks.filter((task) => task.isLeave === true).map((task) => task.id));
        
        leaveTasks = apiLeaveTypes
            .filter((item) => {
                const id = item.id ?? item.taskId;
                return id !== undefined && leaveTaskIds.has(id);
            })
            .map((item) => ({
                id: (item.id ?? item.taskId) as number,
                name: item.name,
                userId: item.userId
            }))
            .sort((a, b) => a.name.localeCompare(b.name));
    }
    return { tasks, leaveTasks };
}
